import { ConfigBtnData } from '../../service/luigiConfig/config-btn-data';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import {
  ButtonComponent,
  ContentDensityDirective,
} from '@fundamental-ngx/core';
import { LuigiCoreService } from '@openmfp/portal-ui-lib';

@Component({
  selector: 'app-config-btn',
  imports: [ButtonComponent, ContentDensityDirective],
  templateUrl: './config-btn.component.html',
  styleUrl: './config-btn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigBtnComponent {
  readonly configBtnData = input.required<ConfigBtnData>();

  private readonly luigiCoreService = inject(LuigiCoreService);

  protected readonly isConfigurable = computed(() => {
    return (
      this.configBtnData()?.isOwner &&
      this.configBtnData()?.hasConfig === 'true' &&
      this.configBtnData()?.category !== 'settings::configurations' &&
      this.configBtnData()?.isInstallableInLevel
    );
  });

  protected openConfig() {
    const params = {
      extClassName: this.configBtnData().extClass,
      scope: this.configBtnData().scope,
      installableIn: this.configBtnData().installableIn,
    };

    this.luigiCoreService
      .navigation()
      .fromContext(params.installableIn.toLowerCase())
      .withParams(params)
      .openAsModal('/extension-configuration');
  }
}
